module.exports = __webpack_public_path__ + "img/photo_250460827_1.96310c86.jpg";